import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import authBeforeEnter from "@/router/auth_before_enter";
import Home from "@/users/home.vue";
import SignIn from "@/auth/signin.vue";
import ChangePassword from "@/auth/change_password.vue";
import FactsIndex from "@/facts/index.vue";
import FactForm from "@/facts/form.vue";
import PublishersIndex from "@/publishers/index.vue";
import PublishersForm from "@/publishers/form.vue";
import DocumentsIndex from "@/documents/index.vue";
import DocumentForm from "@/documents/form.vue";
import EventsIndex from "@/events/index.vue";
import EventForm from "@/events/form.vue";
import CountryProfile from "@/countries/profile.vue";
import MonitoringChallenges from "@/monitoring_challenges/form.vue";
import ContextualAnalysis from "@/contextual_analysis/form.vue";
import SignificantUpdates from "@/significant_updates/form.vue";
import ContactsIndex from "@/contacts/index.vue";
import ContactForm from "@/contacts/form.vue";
import CommunicationsIndex from "@/communications/index.vue";
import CommunicationForm from "@/communications/form.vue";
import IDUs from "@/monitoring_platform/index_idus.vue";
import PerformanceDashboard from "@/dashboards/performance/index.vue";
import QADashboard from "@/dashboards/qa/index.vue";
import AnalysisDashboard from "@/dashboards/analysis/Index.vue";
import Portfolios from "@/portfolios/index.vue";
import TabularDatasetsIndex from "@/tabular_datasets/index.vue";
import TabularDatasetForm from "@/tabular_datasets/form.vue";
import TabularDatasetView from "@/tabular_datasets/view.vue";
import ScaffoldIndex from "@/scaffold/index.vue";
import ScaffoldDocumentFormPage from "@/scaffold/DocumentFormPage.vue";
import ScaffoldParkingLotDocumentsIndexPage from "@/scaffold/ParkingLotDocumentsIndexPage.vue";
import ScaffoldParkingLotFactsIndexPage from "@/scaffold/ParkingLotFactsIndexPage.vue";
import ScaffoldTabularData from "@/scaffold/index-tabular-data.vue";
import ScaffoldParkingLotEventsIndexPage from "@/scaffold/ParkingLotEventsIndexPage.vue";
import ScaffoldIndexTabularDataHandsontable from "@/scaffold/index_tabular_data_handsontable.vue";
import ServerSideFactsTable from "@/scaffold/ServerSideFactsTable.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/scaffold/serverside-facts",
      component: ServerSideFactsTable,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Scaffold - Server Side Facts",
      },
    },
    {
      path: "/scaffold",
      component: ScaffoldIndex,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Scaffold - Index",
      },
    },
    {
      path: "/scaffold/documents/parking_lot",
      component: ScaffoldParkingLotDocumentsIndexPage,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Scaffold - Documents Index",
      },
    },
    {
      path: "/scaffold/facts/parking_lot",
      component: ScaffoldParkingLotFactsIndexPage,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Scaffold - Facts Index",
      },
    },
    {
      path: "/scaffold/documents/parking_lot/:id",
      component: ScaffoldDocumentFormPage,
      beforeEnter: authBeforeEnter,
      props: route => ({ id: parseInt(route.params.id, 10), action: "import" }),
      meta: {
        title: "Scaffold - Document Form",
      },
    },
    {
      path: "/scaffold/documents/clone/:id",
      component: ScaffoldDocumentFormPage,
      beforeEnter: authBeforeEnter,
      props: route => ({ id: parseInt(route.params.id, 10), action: "clone" }),
      meta: {
        title: "Scaffold - Document Clone Form",
      },
    },
    {
      path: "/scaffold/documents/:id",
      component: ScaffoldDocumentFormPage,
      beforeEnter: authBeforeEnter,
      props: route => ({ id: parseInt(route.params.id, 10), action: "" }),
      meta: {
        title: "Scaffold - Document Form",
      },
    },
    {
      path: "/scaffold/tabular-data",
      component: ScaffoldTabularData,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Scaffold - Tabular Data",
      },
    },
    {
      path: "/scaffold/tabular-data-volume",
      component: ScaffoldIndexTabularDataHandsontable,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Scaffold - Tabular Data Volume",
      },
    },
    {
      path: "/scaffold/parking-lot/events",
      component: ScaffoldParkingLotEventsIndexPage,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Scaffold - Events parking lot",
      },
    },
    {
      path: "/dashboards/performance",
      component: PerformanceDashboard,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Performance Dashboard",
      },
    },
    {
      path: "/dashboards/qa",
      component: QADashboard,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "QA Dashboard",
      },
    },
    {
      path: "/dashboards/analysis",
      component: AnalysisDashboard,
      beforeEnter: authBeforeEnter,
      meta: {
        title: "Analysis Dashboard",
      },
    },
    { path: "/signin", component: SignIn, meta: { title: "Signin" } },
    {
      path: "/",
      component: Home,
      beforeEnter: authBeforeEnter,
      meta: { title: "Home" },
    },
    {
      path: "/change_password",
      component: ChangePassword,
      beforeEnter: authBeforeEnter,
      meta: { title: "Change Password" },
    },
    {
      path: "/documents",
      component: DocumentsIndex,
      beforeEnter: authBeforeEnter,
      meta: { title: "Documents" },
    },
    {
      path: "/documents/new",
      component: DocumentForm,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Document" },
    },
    {
      path: "/documents/:id",
      component: DocumentForm,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Document" },
    },
    {
      path: "/documents/clone/:id",
      name: "CloneDocumentRoute",
      component: DocumentForm,
      props: route => ({ id: route.params.id, isClone: true }),
      beforeEnter: authBeforeEnter,
      meta: { title: "Clone Document" },
    },
    {
      path: "/facts",
      component: FactsIndex,
      beforeEnter: authBeforeEnter,
      meta: { title: "Facts" },
    },
    {
      path: "/facts/new",
      name: "NewMasterFactRoute",
      component: FactForm,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Master Fact" },
    },
    {
      path: "/documents/:document_id/facts/new",
      name: "NewFactRoute",
      component: FactForm,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Fact" },
    },
    {
      path: "/facts/clone/:id",
      name: "CloneFactRoute",
      component: FactForm,
      props: route => ({ id: route.params.id, isClone: true }),
      beforeEnter: authBeforeEnter,
      meta: { title: "Clone Fact" },
    },
    {
      path: "/facts/:id",
      component: FactForm,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Fact" },
    },
    {
      path: "/publishers",
      component: PublishersIndex,
      beforeEnter: authBeforeEnter,
      meta: { title: "Publishers" },
    },
    {
      path: "/publishers/new",
      component: PublishersForm,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Publisher" },
    },
    {
      path: "/publishers/:id",
      component: PublishersForm,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Publisher" },
    },
    {
      path: "/events",
      component: EventsIndex,
      beforeEnter: authBeforeEnter,
      meta: { title: "Events" },
    },
    {
      path: "/events/new",
      component: EventForm,
      props: () => ({ action: "New" }),
      beforeEnter: authBeforeEnter,
      meta: { title: "New Event" },
    },
    {
      path: "/events/:id",
      component: EventForm,
      props: route => ({ id: route.params.id, action: "Edit" }),
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Event" },
    },
    {
      path: "/events/clone/:id",
      name: "CloneEventRoute",
      component: EventForm,
      props: route => ({ id: route.params.id, action: "Clone" }),
      beforeEnter: authBeforeEnter,
      meta: { title: "Clone Event" },
    },
    // {
    //   path: "/countries/profiles",
    //   component: CountryProfile,
    //   beforeEnter: authBeforeEnter,
    //   meta: { title: "Country Profiles" }
    // },
    {
      path: "/countries/profiles/:iso3",
      component: CountryProfile,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Country Profiles" },
    },
    {
      path: "/countries/monitoring_challenges/new/:iso3",
      component: MonitoringChallenges,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Monitoring challenge" },
    },
    {
      path: "/countries/monitoring_challenges/:id",
      component: MonitoringChallenges,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Monitoring challenge" },
    },
    {
      path: "/countries/contextual_analysis/new/:iso3",
      component: ContextualAnalysis,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Contextual Analysis" },
    },
    {
      path: "/countries/contextual_analysis/:id",
      component: ContextualAnalysis,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Contextual Analysis" },
    },
    {
      path: "/countries/significant_updates/new/:iso3",
      component: SignificantUpdates,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Significant Updates" },
    },
    {
      path: "/countries/significant_updates/:id",
      component: SignificantUpdates,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Significant Updates" },
    },
    {
      path: "/countries/:iso3",
      component: SignificantUpdates,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Significant Updates" },
    },
    {
      path: "/contacts",
      component: ContactsIndex,
      beforeEnter: authBeforeEnter,
      meta: { title: "Contacts" },
    },
    {
      path: "/contacts/new",
      component: ContactForm,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Contact" },
    },
    {
      path: "/contacts/:id",
      component: ContactForm,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Contact" },
    },
    {
      path: "/communications",
      component: CommunicationsIndex,
      beforeEnter: authBeforeEnter,
      meta: { title: "Communications" },
    },
    {
      path: "/communications/new/:contact_id",
      component: CommunicationForm,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Communication" },
    },
    {
      path: "/communications/:id",
      component: CommunicationForm,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Communication" },
    },
    {
      path: "/tabular-datasets",
      component: TabularDatasetsIndex,
      beforeEnter: authBeforeEnter,
      meta: { title: "Tabular Datasets" },
    },
    {
      path: "/tabular-datasets/new",
      component: TabularDatasetForm,
      beforeEnter: authBeforeEnter,
      meta: { title: "New Tabular Dataset" },
    },
    {
      path: "/tabular-datasets/edit/:id",
      component: TabularDatasetView,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "Edit Tabular Dataset" },
    },
    {
      path: "/tabular-datasets/:id",
      component: TabularDatasetView,
      props: true,
      beforeEnter: authBeforeEnter,
      meta: { title: "View Dataset" },
    },
    {
      path: "/monitoring_platform/idus",
      component: IDUs,
      beforeEnter: authBeforeEnter,
      meta: { title: "IDUs" },
    },
    {
      path: "/portfolios",
      component: Portfolios,
      beforeEnter: authBeforeEnter,
      meta: { title: "Portfolios" },
    },
    {
      path: "/:gsn",
      beforeEnter: (to, from, next) => {
        let directive = to.params.gsn.substr(0, 1);
        if (directive === "@") {
          axios
            .get("/psql/gsn", {
              params: {
                serial_no: `eq.${to.params.gsn.substr(1)}`,
              },
              headers: {
                Accept: "application/vnd.pgrst.object+json",
              },
            })
            .then(response => {
              const gsn = response.data;
              next(`/${gsn.type}/${gsn.id}`);
            })
            .catch(error => {
              console.error(error);
            });
        } else {
          // TODO: Handle directive != "@"
          console.error("Nothing to handle directive != '@' case");
        }
        axios
          .get("/psql/gsn", {
            params: {
              gsn: `eq.${to.params.gsn}`,
            },
            headers: {
              Accept: "application/vnd.pgrst.object+json",
            },
          })
          .then(response => {
            const gsn = response.data;
            next(`/${gsn.type}/${gsn.id}`);
          })
          .catch(error => {
            console.error(error);
          });
      },
    },
  ],
});
